import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {map, take} from 'rxjs/operators';
import {UserInfo} from 'firebase';

@Injectable({providedIn: 'root'})
export class OwnerGuard implements CanActivate {

  readonly loggedIn$: Observable<UserInfo>;

  constructor(private store: Store<any>) {
    this.loggedIn$ = this.store.select(anState => anState.auth.user);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    console.log('params are ', route.paramMap)
    if (!route.paramMap.has('userId')) {
      console.log('couldn\'t find user id');
      return false;
    } else {
      const userName = route.paramMap.get('userId');
      console.log('user name is ', userName);
      return this.loggedIn$.pipe(
        take(1),
        map((user) => user.displayName === userName));
    }
  }
}
